export const LoadingDots = () => {
    return (
        <div className="flex justify-center items-center gap-2">
            <span className="animate-grow rounded-full h-1 w-1 bg-primaryHalf"></span>
            <span className="animate-grow animation-delay-200  animate rounded-full h-1 w-1 bg-primaryHalf"></span>
            <span className="animate-grow animation-delay-400 rounded-full h-1 w-1 bg-primaryHalf"></span>
        </div>
    );
};
